var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.orientationCustomize,
    _vm.alignVerticalCustomize,
    _vm.hasGrid ? _vm.gridCustomize : [_vm.xlGrid, _vm.lgGrid, _vm.mdGrid, _vm.smGrid],
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }